
import React, { Component } from 'react';
import { Redirect, Route } from "react-router-dom";
import Home from './pages/Home'
 import './App.css';
 const AppRoute = (
  <>

<Route exact path="/:id" component={Home} />






     </>
   );



export default AppRoute;
